'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import unescapedText from 'I18n/utils/unescapedText';
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import * as FilterKey from '../../../../constants/search/FilterKey';
import { getDisplayedCollectionListings } from '../../../../selectors/collections';
import { getCollectionI18nKey, validUnescapedText } from '../../../../utils/i18n';
import classNames from 'classnames';

const CollectionsNav = ({
  className,
  isAdminPreview,
  trackFilterNavItemClick,
  closeMobilePanel
}) => {
  const collectionListings = useSelector(getDisplayedCollectionListings);
  const {
    collectionId: previewCollectionId
  } = useParams();
  return /*#__PURE__*/_jsxs(UIRouterSideNav, {
    className: classNames('m-bottom-0', className),
    children: [/*#__PURE__*/_jsx(UIRouterSideNavItem, {
      onClick: () => {
        if (closeMobilePanel) {
          closeMobilePanel();
        }

        return !isAdminPreview && trackFilterNavItemClick(FilterKey.COLLECTION, 'all collections');
      },
      title: unescapedText('appMarketplace.storefront.filters.collection.items.all.titleText'),
      to: isAdminPreview ? '#' : '/'
    }), collectionListings.map(listing => {
      const {
        id: listingId,
        collectionId,
        name,
        slug
      } = listing;
      const trackingId = `${collectionId}${listingId ? `_${listingId}` : ''}`;
      const seleniumId = `${slug}-collection`;
      const titleKey = typeof collectionId === 'string' ? getCollectionI18nKey(collectionId) : `appMarketplace.collections.collection_${collectionId}.name`; // Style the currently previewed collection as active

      const adminPreviewLink = `${collectionId}` === previewCollectionId ? `/collections/${collectionId}` : '#';
      return /*#__PURE__*/_jsx(UIRouterSideNavItem, {
        "data-selenium-id": seleniumId,
        exact: false,
        onClick: () => {
          if (closeMobilePanel) {
            closeMobilePanel();
          }

          return !isAdminPreview && trackFilterNavItemClick(FilterKey.COLLECTION, trackingId);
        },
        title: validUnescapedText(titleKey, {}, name),
        to: isAdminPreview ? adminPreviewLink : `/${slug}`
      }, collectionId);
    })]
  });
};

CollectionsNav.propTypes = {
  className: PropTypes.string,
  closeMobilePanel: PropTypes.func,
  isAdminPreview: PropTypes.bool,
  trackFilterNavItemClick: PropTypes.func.isRequired
};
export default CollectionsNav;